export default {
  basket: [],
  address_id: null,
  address_name: null,
  card_token: null
}
